export const allowedAdminEmails = [
 
  "mhamedadm60@gmail.com",
];
